/*
 * @Description:
 * @Author: Rabbiter
 * @Date: 2023-03-26 15:27:05
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './resource/font/iconfont.css'
import '@/resource/global.css'
import ElementUI from 'element-ui';
import request from './utils/request';
import './resource/font2/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css';
// V2企业整单折扣：全局注入 entRate/dpEnt（仅展示层；下单金额由后端权威计算）
import { loadEntDiscount, dp } from '@/utils/entPrice'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.request=request;

Vue.mixin({
  data() { return { entRate: 1 } },
  created() {
    loadEntDiscount().then(c => { this.entRate = c.rate }).catch(() => {})
  },
  methods: {
    dpEnt(p) { return dp(p, this.entRate) }
  }
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
